import { useEffect, useState } from "react"
import { MySelector, MyDispatch } from "../../redux/store"
import { useDispatch } from "react-redux"
import { setShowUploadModal } from "../../redux/utilSlice"
import { useLocation } from "react-router-dom"

const FloatingUploadButton = () => {
  const dispatch = useDispatch<MyDispatch>()
  const location = useLocation()
  const { config } = MySelector((state) => state.event)
  const { aiSearchActive } = MySelector((state) => state.util)

  // Reveal only after scrolling down a bit, so it doesn't sit over the cover.
  const [scrolled, setScrolled] = useState(false)

  // Only show if guest uploads are enabled, on the gallery page, and not on the
  // AI Search view (which isn't a real folder to upload into).
  const shouldShow =
    config?.guestUploadEnabled &&
    location.pathname.includes("/gallery") &&
    !aiSearchActive

  useEffect(() => {
    if (!shouldShow) return
    const container = document.querySelector(
      ".max-h-screen.overflow-y-scroll"
    ) as HTMLElement | null
    if (!container) return
    const handleScroll = () => {
      setScrolled(container.scrollTop > window.innerHeight * 0.1)
    }
    handleScroll()
    container.addEventListener("scroll", handleScroll, { passive: true })
    return () => container.removeEventListener("scroll", handleScroll)
  }, [shouldShow, location.pathname])

  if (!shouldShow) return null

  return (
    <button
      onClick={() => dispatch(setShowUploadModal(true))}
      className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-[1000] bg-blue-600 hover:bg-blue-700 text-white rounded-full px-6 py-4 shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-3 ${
        scrolled
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      aria-label="Upload files"
    >
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
        />
      </svg>
      <span className="text-sm font-medium whitespace-nowrap">
        Upload Files
      </span>
    </button>
  )
}

export default FloatingUploadButton
